import React from "react";
import ReactDOM from "react-dom";
import "./App.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Login from "./components/Login";
import Register from "./components/Register";

ReactDOM.render(
  <BrowserRouter>
    <Route exact path="/" render={(props) => <Login {...props} />} />
    <Route path="/register" render={(props) => <Register {...props} />} />
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
